import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import { Dashboard } from '../views/Admin/Dashboard'


class mainbuilder extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/admin" render={props => <Dashboard {...props} />} />
            </Switch>
        )
    }
}

export default mainbuilder